import {PropertyTypeEnum} from 'module/Properties/enum/PropertyTypeEnum'

export function genCompositeId(object: string, attribute: string, type: PropertyTypeEnum = PropertyTypeEnum.UserProperty, subkrit: string | null = null) {
	return `${object}_${attribute}_${type}` + (type === PropertyTypeEnum.Paramdiv ? '_' + subkrit : '')
}

export function propDefaultTrue(p: null | undefined | string) {
	return p !== 'N'
}

export function propDefaultFalse(p: null | undefined | string) {
	return p === 'J'
}
